module.exports = __webpack_public_path__ + "static/media/tools-activities.df34c28c.svg";